window.CDQ = {
	component: {},
	core: {},
	global: {},
	i: {}
};